<template lang="pug">
  .not-found
    .not-found-content
      h2 404 page not found
      p We are sorry but the page you are looking for does not exist.
    .clearfix
</template>

<script>
  export default {
    data () {
      return {

      }
    }
  }
</script>

<style lang="less">
.not-found {

}
</style>
